module.exports = __webpack_public_path__ + "static/media/design-img-5.65e1547d.jpg";